export default __webpack_public_path__ + "static/media/bg_coming_soon.75f4a286.png";